import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/resetMfa/user.resetMfa.mutation.gql"
import type {
  UserResetMfaMutation,
  UserResetMfaMutationVariables,
} from "@/v2-backoffice-client/user/resetMfa/__types__/user.resetMfa.mutation"

type Options = MutationHookOptions<
  UserResetMfaMutation,
  UserResetMfaMutationVariables
>

export function useUserResetMfaMutation(options?: Options) {
  return useMutation<UserResetMfaMutation, UserResetMfaMutationVariables>(
    mutation,
    options,
  )
}
